// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,
	usetifulToken: '269f067d6d58bfe9e035514506431ee2',
	mixPanelToken: 'bde23a3b5f379b87c14e42ae3bbd0cd3',
	dataDog: {
		appId: '52c92b3c-e8c1-43bd-9366-2ae78058e2f4',
		clientToken: 'pubd24da34a2b15172f3838de9dab154667'
	}
};
